import React from 'react';

export var MicIcon = function MicIcon(props) {
  return React.createElement(
    "svg",
    {
      "data-qa": "MicIcon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      height: "100%",
      preserveAspectRatio: "none",
      viewBox: "0 0 1060 1060"
    },
    React.createElement("circle", { fill: props.circleColor, cx: "530", cy: "530", r: "512" }),
    React.createElement("path", {
      fill: props.iconColor,
      transform: "matrix(0.54,0,0,-0.54,238,860)",
      d: "M 538 451 c 76 0 138 63 138 141 l 0 281 c 0 78 -62 141 -138 141 s -138 -63 -138 -141 v -281 c 0 -78 62 -141 138 -141 v 0 z M 782 592 c 0 -141 -117 -239 -244 -239 s -244 98 -244 239 h -78 c 0 -160 125 -292 276 -315 v -154 h 92 v 154 c 151 23 276 155 276 315 h -78 z"
    })
  );
};